function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import { cmsActions } from '../../../reducers/cms.reducer';
import ModalHeader from '../../modal/ModalHeader.react';
import Input from '../../common/form/Input.react';
import Label from '../../common/form/Label.react';
import Button from '../../common/Button.react';
import Select from '../../common/form/Select.react';
var PopupFilesAttach = function PopupFilesAttach(_ref) {
  var popupID = _ref.popupID,
    fileID = _ref.fileID,
    files = _ref.files,
    popupsAction = _ref.popupsAction,
    removeModalAction = _ref.removeModalAction;
  var _useState = useState({
      title: '',
      slot: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  useEffect(function () {
    var file = files.find(function (x) {
      return x._id === fileID;
    });
    if (!file) return;
    setForm({
      title: file.title
    });
  }, []);
  var title = form.title,
    slot = form.slot;
  var isValid = function isValid() {
    return title.length > 0;
  };
  var slotArr = [{
    sLabel: 'First',
    sValue: 0
  }];
  files.filter(function (x) {
    return x._id !== fileID;
  }).sort(function (a, b) {
    return a.slot - b.slot;
  }).forEach(function (x, i) {
    slotArr.push({
      sLabel: "After ".concat(x.title),
      sValue: i + 1
    });
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "Update Document Details"
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body upload-image"
  }, /*#__PURE__*/React.createElement(Label, {
    label: "Title",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: title,
    onChange: function onChange(e) {
      return setForm(_objectSpread(_objectSpread({}, form), {}, {
        title: e.target.value
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Slot",
    required: true
  }), /*#__PURE__*/React.createElement(Select, {
    value: slot,
    options: slotArr,
    onChange: function onChange(position) {
      setForm(_objectSpread(_objectSpread({}, form), {}, {
        slot: position.sValue
      }));
    },
    placeholder: "Select to change position",
    permission: "edit-pos-popup"
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      var arr = null;
      if (slot != 'null') {
        var count = 0;
        arr = [];
        var sortedFiles = files.filter(function (x) {
          return x._id !== fileID;
        }).sort(function (a, b) {
          return a.slot - b.slot;
        });
        for (var i = 0; i < sortedFiles.length + 1; i++) {
          if (i === slot) {
            arr.push(_objectSpread(_objectSpread({}, files.find(function (x) {
              return x._id === fileID;
            })), {}, {
              slot: slot
            }));
          } else {
            arr.push(_objectSpread(_objectSpread({}, sortedFiles[count]), {}, {
              slot: i
            }));
            count++;
          }
        }
      }
      popupsAction({
        formData: {
          popupID: popupID,
          fileID: fileID,
          title: title,
          slotArr: arr
        },
        method: 'put',
        route: 'files'
      });
      removeModalAction();
    },
    label: "Update",
    disabled: !isValid(),
    style: {
      width: '100%',
      marginBottom: 15
    }
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return removeModalAction();
    },
    label: "Close",
    type: "cancel",
    style: {
      width: '100%'
    }
  })));
};
var mdtp = {
  popupsAction: cmsActions.popups,
  removeModalAction: modalActions.remove
};
export default connect(null, mdtp)(PopupFilesAttach);